<div class="addresses-management-container">
  <div class="actions" fxLayout="row" fxLayoutAlign="start center">
    <button
      class="add-btn"
      mat-flat-button
      color="primary"
      (click)="addAddress()"
    >
      اضافه کردن آدرس جدید
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="addresses-list">
    <editable-address-container></editable-address-container>
  </div>
</div>
